/* eslint-disable import/no-extraneous-dependencies */
import React, { PropTypes } from 'react'
import cn from 'classnames'
import BackIcon from 'resources/back.svg'
import CloseIcon from 'resources/images/close_2x.png'
import MenuIcon from 'resources/images/menu_2x.png'
import WillBrockerLogo from 'resources/images/BE_Logo_OVB_Willemot_White.svg'
import EasinsureLogo from 'resources/easinsure/easinsure-logotype.svg'
import UpdateBar from './UpdateBar'
import styles from './Header.scss'

const Header = ({isLoggedIn, isPhone, isTablet, isClient, backButton, ...props}) => {
    if (!isLoggedIn) {
        return <UpdateBar/>
    }

    if (!isPhone && !isTablet) {
        return null // no header on desktop
    }

    return (
        <div className={cn(styles.mobileHeader, isClient ? styles.myEasinsure : styles.willBroker, props.className)}>
            {backButton && (
                <div className={styles.backBtn} onClick={props.onBack}>
                    <img src={BackIcon}/>
                    Back
                </div>
            )}
            {isClient ? (
                <div className={styles.brandEasinsure}>
                    <img className={styles.logo} src={EasinsureLogo}/>
                </div>
            ) : (
                <div className={styles.brandWillemot}>
                    <div className={styles.menu} onClick={props.onMenu}>
                        <img src={props.menuActive ? CloseIcon : MenuIcon}/>{' '}Menu
                    </div>
                    <div className={styles.logo}>
                        <img onClick={props.onHome} src={WillBrockerLogo}/>
                    </div>
                </div>
            )}
        </div>
    )
}
Header.propTypes = {
    menuActive: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    isPhone: PropTypes.bool,
    isTablet: PropTypes.bool,
    isClient: PropTypes.bool, // props comes from environment ??
    backButton: PropTypes.bool,
    className: PropTypes.string,
    onBack: PropTypes.func,
    onMenu: PropTypes.func,
    onHome: PropTypes.func,
}

export default Header



// WEBPACK FOOTER //
// ./components/mainComponents/Header.jsx